import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from 'services/translation';
import BookingsApi from 'data_system/bookings/api';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import { ConfirmEmailModal } from './ConfirmEmailModal';

const ConfirmEmail = ({ email, bookingIdHash, setEmail }) => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (emailValue) => {
    setIsLoading(true);
    let params = {
      email: emailValue,
    };
    BookingsApi.notifyGuest(bookingIdHash, params)
      .then((response) => {
        if (response && response.status === 200) {
          setEmail(response.data.email);
        }
      })
      .finally(() => {
        setIsEmailModalOpen(false);
        setIsLoading(false);
      });
  };

  return (
    <div id="confirm-email" className="confirm-email">
      <p className="confirm-email-sent-to">{t('SENT_TO')}</p>
      <p className="confirm-email-address">{email}</p>
      <button
        type="button"
        className="confirm-email-edit-button brand-color"
        onClick={() => setIsEmailModalOpen(true)}
        onKeyDown={(e) => isActionKey(e.key) && setIsEmailModalOpen(true)}
        data-testid="edit-guest-email"
      >
        {t('EDIT')}
      </button>
      <ConfirmEmailModal
        className="confirm-email-modal"
        email={email}
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        onSubmit={handleEmailChange}
        isLoading={isLoading}
      />
    </div>
  );
};

ConfirmEmail.propTypes = {
  email: PropTypes.string,
  bookingIdHash: PropTypes.string,
  setEmail: PropTypes.func,
};

export default ConfirmEmail;
